import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Checkbox } from '..';
import { settings, SAVE_BUTTON_TEXT, UNIT, SUITABLE_ORDER_TYPES } from '../../constants';
import Input from '../Input';
import Paper from '../Paper';
import Spinner from '../Spinner';
import Button from '../Button';
import BackButton from '../BackButton';
import * as actions from '../../actions/index';
import Switch from '../Switch';
import { handleSubmitData, initDataConfig, handleToggle, handleCheckboxChange, handleChange, checkMinMaxValue } from './ManagementFee.services';
import { styles } from './ManagementFee.styles';
import { ICON_ORDER_TYPES } from '../../constants';

const INITIAL_STATE = {
    managementFeeData: {
        enabled: false,
        delivery: {
            fee: 0,
            maxFee: 0,
            minFee: 0,
            hasFixedValue: false
        },
        click_and_collect: {
            fee: 0,
            maxFee: 0,
            minFee: 0,
            hasFixedValue: false
        },
        click_and_seat: {
            fee: 0,
            maxFee: 0,
            minFee: 0,
            hasFixedValue: false
        }
    },
    isLoading: false
};

interface ManagementFeesProps {
    managementFee: any;
    orderTypes: string[];
    classes: any;
    history: any;
    openErrorModal: (error: string) => void;
}

const ManagementFees: React.FC<ManagementFeesProps> = ({ classes, history, managementFee, orderTypes, openErrorModal }) => {
    const [state, setState] = useState(INITIAL_STATE);
    const { isLoading, managementFeeData } = state;

    useEffect(() => {
        initDataConfig(managementFee, managementFeeData, setState);
    }, [managementFee]);

    const renderSwitch = () => {
        return (
            <>
                <List>
                    <ListItem style={{ width: `${UNIT * 5}%` }}>
                        <ListItemText className='row m-0 p-3'>
                            <p className={`col-sm-12 mt-2  ${classes.headerFee}`}>
                                Par défaut les frais de gestion définis dans le réglages des restaurants seront appliqués:
                            </p>
                        </ListItemText>
                        <ListItemSecondaryAction>
                            <Switch
                                onChange={() => handleToggle(setState, managementFeeData)}
                                checked={managementFeeData.enabled}
                                color='primary'
                            />
                        </ListItemSecondaryAction>
                    </ListItem>
                </List>
                {managementFeeData.enabled && renderManagementFee()}
            </>
        );
    };

    const renderManagementFee = () => {

        return (
            <div className='col-12'>
                <div className='row col-12 mt-2 align-items-center ml-2 mt-2'>
                    <div className='d-flex justify-content-end ml-lg-5 ml-md-4 col-lg-3 col-md-5 col-sm-10'>
                        <b>Une valeur fixe ?</b>
                    </div>
                </div>
                {_.map(managementFeeData, (orderType, key) => {
                    const { fee, minFee, maxFee, hasFixedValue } = orderType;
                    if (orderTypes.includes(key)) {
                        return (
                            <div className='row col-12 mt-2 align-items-center ml-0 mt-2' key={key}>
                                <div className='d-flex align-items-center col-lg-4 col-md-6 col-sm-12'>
                                    <ListItemIcon>{ICON_ORDER_TYPES[key]}</ListItemIcon>
                                    <ListItemText
                                        className={classes.itemText}
                                        primary={SUITABLE_ORDER_TYPES[key]}
                                    />
                                    <Checkbox
                                        className={`${classes.checkboxStyle} col-4`}
                                        value={hasFixedValue}
                                        name='hasFixedValue'
                                        onClick={() => handleCheckboxChange(setState, key)}
                                    />
                                </div>
                                <div className='d-flex flex-wrap col-lg-8 col-md-6 col-sm-12 mt-2'>
                                    {hasFixedValue ? (
                                        <div className={`col-lg-4 col-md-6 col-sm-12 ${classes.fee}`}>
                                            <Input
                                                margin='dense'
                                                id='fee'
                                                label='Valeur fixe'
                                                type='number'
                                                fullWidth
                                                value={fee}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, setState, key)}
                                                InputProps={{

                                                    endAdornment: <InputAdornment position='end'>€</InputAdornment>
                                                }}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <div className={`col-lg-4 col-sm-12 ${classes.fee}`}>
                                                <Input
                                                    margin='dense'
                                                    id='fee'
                                                    label='Pourcentage du panier'
                                                    type='number'
                                                    fullWidth
                                                    value={fee}
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, setState, key)}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position='end'>%</InputAdornment>
                                                    }}
                                                />
                                            </div>
                                            <div className={`col-lg-4 col-sm-12 ${classes.fee}`}>
                                                <Input
                                                    margin='dense'
                                                    id='minFee'
                                                    type='number'
                                                    label='Valeur minimale'
                                                    fullWidth
                                                    value={minFee}
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, setState, key)}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position='end'>€</InputAdornment>
                                                    }}
                                                />
                                            </div>
                                            <div className={`col-lg-4 col-sm-12 ${classes.fee}`}>
                                                <Input
                                                    margin='dense'
                                                    id='maxFee'
                                                    type='number'
                                                    label='Valeur maximale'
                                                    fullWidth
                                                    value={maxFee}
                                                    onBlur={e => { checkMinMaxValue(e, setState, minFee, key) }}
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, setState, key)}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position='end'>€</InputAdornment>
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        );
    };


    return (
        <div className='p-4'>
            <BackButton
                className='p-0'
                onClick={() => history.goBack()}
                title={settings.managementFee.text}
                subtitle={settings.managementFee.description}
            />
            <Paper className={`col-12 px-0 my-3 ${classes.paperStyle}`}>
                {renderSwitch()}
                <div className='d-flex w-100 justify-content-center justify-content-sm-end align-items-center p-4'>
                    <div className={`px-sm-${isLoading ? 5 : 0} `}>
                        {isLoading ? (
                            <Spinner size={30} />
                        ) : (
                            <Button
                                color='primary'
                                onClick={() => handleSubmitData(setState, managementFeeData, openErrorModal)}
                                className='btn-primary'
                            >
                                <div className='row justify-content-center align-items-center mr-0 ml-0'>
                                    <p className='mx-0'>{SAVE_BUTTON_TEXT}</p>
                                </div>
                            </Button>
                        )}
                    </div>
                </div>
            </Paper>
        </div>
    );
};

const mapStateToProps = ({ firebaseRealTime }) => {
    const { generalConfig = {} } = firebaseRealTime;
    const { managementFee, orderTypes } = generalConfig;
    return { managementFee, orderTypes };
};

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(ManagementFees)));
